import { useRef } from "react";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

export function Quote() {
  const sectionRef = useRef<HTMLElement>(null);

  useScrollReveal(sectionRef, { targets: "p", duration: 0.9 });

  return (
    <section
      ref={sectionRef}
      id="section-four"
      className="section section-masthead text-left bg-dark-1"
      data-arts-theme-text="light"
    >
      <div className="flex-column right-menu-padding left-section-padding">
        <div className="fourth-section">
          <div className="left" />
          <div className="right">
            <div className="section-masthead__heading">
              <p>
                Construction project management software allows teams and their project
                information to connect, enabling improved decision making at a faster response
                with fewer errors.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
